import React from 'react';

interface LineChartProps {
  data: { x: number; y: number }[]; // x is timestamp, y is value
}

const formatDate = (timestamp: number) => {
    return new Date(timestamp).toLocaleDateString('cs-CZ', { month: 'numeric', day: 'numeric' });
};

export const LineChart: React.FC<LineChartProps> = ({ data }) => {
    const width = 500;
    const height = 200;
    const padding = 40;

    if (data.length < 2) return <p className="text-center text-gray-500">Nedostatek dat pro zobrazení grafu.</p>;

    const minX = Math.min(...data.map(d => d.x));
    const maxX = Math.max(...data.map(d => d.x));
    const minY = Math.min(...data.map(d => d.y));
    const maxY = Math.max(...data.map(d => d.y));

    const getX = (x: number) => padding + ((x - minX) / (maxX - minX)) * (width - 2 * padding);
    const getY = (y: number) => (height - padding) - ((y - minY) / (maxY - minY)) * (height - 2 * padding);
    
    const path = data.map((d, i) => {
        const command = i === 0 ? 'M' : 'L';
        return `${command} ${getX(d.x)} ${getY(d.y)}`;
    }).join(' ');

    const xTicks = [minX, minX + (maxX - minX)/2, maxX];

    return (
        <div className="w-full flex justify-center">
        <svg viewBox={`0 0 ${width} ${height}`} className="font-sans">
            {/* Y axis */}
            <line x1={padding} y1={padding/2} x2={padding} y2={height - padding} stroke="#D1D5DB" />
            <text x={padding - 5} y={padding/2} textAnchor="end" fontSize="10" fill="#6B7280">{maxY.toFixed(2)}</text>
            <text x={padding - 5} y={height - padding} textAnchor="end" fontSize="10" fill="#6B7280">{minY.toFixed(2)}</text>

            {/* X axis */}
            <line x1={padding} y1={height - padding} x2={width - padding / 2} y2={height - padding} stroke="#D1D5DB" />
            {xTicks.map((tick, i) => (
                <text key={i} x={getX(tick)} y={height - padding + 15} textAnchor="middle" fontSize="10" fill="#6B7280">
                    {formatDate(tick)}
                </text>
            ))}

            {/* Line */}
            <path d={path} fill="none" stroke="#3B82F6" strokeWidth="2" />

            {/* Points */}
            {data.map((d, i) => (
                <circle key={i} cx={getX(d.x)} cy={getY(d.y)} r="3" fill="#3B82F6" />
            ))}
        </svg>
        </div>
    );
};